<template>
    <kgr-searchable-dropdown
        display="displayNameWithCategoryAndDepartment"
        :label="label"
        :options="filteredFees"
        :loading="loading"
        @post-input="onInput"
    />
</template>

<script>
import ClubFee from '../../../../js/dto/ClubFee.js';
import ClubFeeCategory from '../../../../js/dto/ClubFeeCategory.js';
import ClubFeeRepository from '../../../../js/repository/ClubFeeRepository.js';
import SearchableDropdown from './SearchableDropdown.vue';

export default {
    components: {
        'kgr-searchable-dropdown': SearchableDropdown,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        value: {
            type: ClubFee,
            default: () => null,
        },
        filterByCategory: {
            type: ClubFeeCategory,
            required: false,
            default: () => null
        },
        hideLabel: {
            type: Boolean,
            required: false,
            default: false,
        },
        inline: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            loading: true,
            clubFees: [],
        }
    },
    computed: {
        label() {
            return this.hideLabel ? null : this.$t('clubFee');
        },
        filteredFees() {
            const fees = this.clubFees;
            if(this.filterByCategory) {
                return fees.filter((fee) => fee.category.id === this.filterByCategory.id);
            }
            return fees;
        }
    },
    created() {
        this.reload();
    },
    methods: {
        reload() {
            ClubFeeRepository
                .findByClubIdExcludeArchivedAndSalesList(this.clubId)
                .then(data => {
                    this.loading = false;
                    this.clubFees = data;
                })
                .catch(() => this.$notify.error('error.loadingData'));
        },
        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        }
    }
}
</script>
